import React from "react";
import Header from "../header/index";
import Group8918 from "../../assets/Group8918.svg";
import "./style.css";

const Team = () => {
  return (
    <>
      <div className="team">
        <div className="pb-lg-5 pb-1">
          <Header img={Group8918} heading="OUR TEAM" />
        </div>
        <div className="container pb-5">
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-4 pt-md-3 pt-sm-5 pt-xs-5 px-md-5 px-4">
              <p className="h2">Our Team</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-4 py-md-3 py-sm-5 py-xs-5 px-md-5 px-4">
              <p className="about-text">
                <p>
                  The GAD School team is enthusiastic about the skills we teach
                  and the opportunities we create for our students. Discover why
                  we enjoy what we do and the people with whom we work.
                </p>
                <p>
                  We have been honored to teach children for over 10 years. All
                  of our teachers are highly qualified and competent. We make
                  use of the most latest teaching materials.
                </p>
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Principal</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Manjit S Aulakh
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Vice Principal</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Kalpna Virk
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Nicole Arondus
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Kindergarten</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Raman Saran
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Prajatka Trehan
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Mandeep Kaur Sohal
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Inderpreet Gill
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 1</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Rajwinder Bhangoo
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Pavan Bath
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Baldish K Aujla
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 2</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Dheeraj Devgon
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Sharndeep Jawanda
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Geetika Harjai
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Brooke Westermann
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 3</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Sukhraj Sandhu
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Ramandeep Kaur
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Shruti Sharma
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Dilsher Aujla
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 4</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Fritz Dean Firgo
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Bertharene Aveau
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Rachel Grolman
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Harsimer Dhillon
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 5</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Kuljit Kaur
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Sarabjit Singh
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 6</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Chet Galpin
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Pawandeep Kaur
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Japanjot Kaur
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 7</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Taylor Schollen
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Ritu Rana
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 8</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Pratibha Unni
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Grade 9</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Pritpal Saini
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">PHE</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Eric Repking
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Punjabi</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Gujinder K Marwah
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Ipinderjit K Marwah
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Amanjot K Sahni
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Tabla</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Didar S Sohi
              </p>
            </div>
          </div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Kirtan</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Davinder Singh
              </p>
            </div>
          </div>
          {/* <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">French</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Japanjot Singh
              </p>
            </div>
          </div> */}
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">LST</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Vandana Mittal
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Education Assistant</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Sanj Deol
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Annrary Charles
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Library</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Ranjit Aulakh
              </p>
            </div>
          </div>
          {/* <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Computer</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Brahmjot Bains
              </p>
            </div>
          </div> */}
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Accounts</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Rupinder Sekhon
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Secretary</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
          {/* <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Swarnjit Sohi
              </p>
            </div> */}
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Kanwaljot Kaur
              </p>
            </div>
            {/* <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Prabh Basra
              </p>
            </div> */}
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Yadveer Kaur
              </p>
            </div>
          </div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Office Assistant</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
          <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Swarnjit Sohi
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          {/* <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Accounts</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Rupinder Sekhon
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Pre School</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Harpreet Gill
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Bhangra Coach</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Arshdip Khosa
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Jasbir Singh
              </p>
            </div>
          </div>
          <div className="hr-team mt-5 mb-2"></div>
          <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Gatka Coach</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Jagjit Singh Nijjar
              </p>
            </div>
          </div> */}
          {/* <div className="row pt-lg-5 pt-4 pb-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-lg-1 pt-md-3 pt-sm-5 pt-xs-5 px-md-1 px-3">
              <p className="h2">Bus Drivers</p>
            </div>
          </div>
          <div className="row pt-1 px-lg-4 px-md-5">
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Boota Singh
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Baljinder Singh
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Mandeep Assi
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Davinder Singh
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Sukhinderpal Deol
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Bikramjit Judge
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Tarlok Singh Klair
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Mrs Sohi
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Pardeep K Dhaliwal
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Sarbjit Kaur Dhillon
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-sm-12 col-xs-12 px-lg-1 py-md-3 py-sm-5 py-xs-5 px-md-1 px-3">
              <p className="about-text font-weight-bold">
                <span className="vertical-ruler">|</span> Jasbir Singh
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Team;
